<div class="row form-group">
  <div class="col-4 mt-3">
    <button #btnAdicionarExecutora (click)="adicionar()" data-toggle="modal" data-target="#dialogExecutora"
      class="btn btn-sm btn-success">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar avaliação
    </button>
  </div>
</div>
<div class="row form-group">
  <div class="col-12">
    <div class="table-responsive" style="height: 100vh;">
      <table class="table table-eddy" *ngIf="listaAvaliacoes && listaAvaliacoes.length > 0">
        <thead>
          <tr>
            <th scope="col">Data de avaliação</th>
            <th scope="col">Situação</th>
            <th scope="col">Observações</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaAvaliacoes; let idx = index">
            <td *ngIf="!item.editavel" style="width: 20%">{{item.data_avaliacao | date:'dd/MM/yyyy':'GMT'}}</td>
            <td *ngIf="!item.editavel" style="width: 20%">{{item.situacao}}</td>
            <td *ngIf="!item.editavel" style="width: 70%">{{item.observacao}}</td>
            <td *ngIf="item.editavel" style="width: 20%">
              <p-calendar #InputFocus id="data_avaliacao" [(ngModel)]="entity.data_avaliacao"
                [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
                [style]="{ width: '100%' }" inputId="data_avaliacao">
              </p-calendar>
            </td>
            <td *ngIf="item.editavel" style="width: 20%">
              <select [(ngModel)]="entity.situacao" [ngModelOptions]="{standalone: true}" class="form-control">
                <option value="PARALISADO">PARALISADO</option>
                <option value="EM ANDAMENTO">EM ANDAMENTO</option>
                <option value="CONCLUIDO">CONCLUÍDO</option>
              </select>
            </td>
            <td *ngIf="item.editavel" style="width: 65%">
              <textarea [(ngModel)]="entity.observacao" [ngModelOptions]="{standalone: true}" class="form-control"
                id="obs" rows="2"></textarea>
            </td>
            <td class="text-right" style="min-width: 150px;">
              <button *ngIf="!item.editavel" (click)="editar(item)" data-toggle="modal" data-target="#dialogExecutora"
                class="btn btn-sm btn-outline-primary mr-2">
                <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
              </button>
              <button *ngIf="!item.editavel" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
                <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
              </button>
              <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
                <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
              </button>
              <button *ngIf="item.editavel" (click)="cancelar(idx)" class="btn btn-sm btn-outline-primary mr-2">
                <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
